<template>
    <div class="loginContent">
        <div class="loginBox">

            <img src="@/assets/img/close.png" class="closeing" @click="closeMask">

            <div class="maintitle">{{ type == 3 ? '账号密码找回' : (type == 1 ? '用户登录' : '账号注册') }}</div>
            <div v-if="type == 1" class="descLo">欢迎回来，请登录您的账户</div>
            <!-- 用户登录 手机密码 -->
            <div class="neic" v-if="type == 1">
                <div class="phoneBox">
                    <div>
                        <img src="@/assets/img/phoneIcon.png">
                    </div>
                    <div>
                        <el-input class="inputClass" type="text" maxlength="11" placeholder="请输入手机号"
                            v-model="loginForm.phonenumber" />
                    </div>
                </div>
                <div class="emptyContent"></div>
                <div class="phoneBox">
                    <div>
                        <img src="@/assets/img/yanzheng.png">
                    </div>
                    <div>
                        <el-input class="inputClass" type="password" placeholder="请输入密码" v-model="loginForm.password" />
                    </div>
                </div>

                <div class="czContent">
                    <div @click="setRegister">{{ type == 1 ? '没有账号去注册' : '已有账号去登录' }}</div>
                    <div>|</div>
                    <div @click="forgetTap">忘记密码?</div>
                </div>
                <div class="startButton" @click="loginIn">{{ type == 1 ? '登录' : (type == 2 ? '注册' : '确定重置') }}</div>
                <div class='tokenDay'>
                    <el-checkbox class="checkb" v-model="agreeMS"></el-checkbox>
                    <span @click="agreeMS = !agreeMS" class="qz">我已阅读并同意</span>
                    <span @click.stop="goAgreement(1)" class="xy">《服务协议》</span>
                    <span @click.stop="goAgreement(2)" class="xy">《隐私政策》</span>
                </div>
            </div>

            <!-- 用户注册 手机号 密码 -->
            <div class="neic" v-if="type == 2">
                <!-- 注册类型标签页 -->
                <div class="register-tabs">
                    <div :class="['tab-item', { active: registerType === '01' }]" @click="registerType = '01'">
                        个人注册
                    </div>
                    <div :class="['tab-item', { active: registerType === '02' }]" @click="registerType = '02'">
                        企业注册
                    </div>
                </div>

                <!-- 企业注册表单 -->
                <template>
                    <div class="emptyContent"></div>
                    <div class="phoneBox">
                        <div>
                            <img src="@/assets/img/nicheng.png">
                        </div>
                        <div>
                            <el-input class="inputClass" type="text"
                                :placeholder="registerType == '02' ? '请输入企业名称' : '请输入个人名称'"
                                v-model="registerForm.username" />
                        </div>
                    </div>
                </template>

                <!-- 共用表单字段 -->
                <div class="emptyContent"></div>
                <div class="phoneBox">
                    <div>
                        <img src="@/assets/img/phoneIcon.png">
                    </div>
                    <div>
                        <el-input class="inputClass" type="text" maxlength="11" placeholder="请输入手机号"
                            v-model="registerForm.phonenumber" />
                    </div>
                </div>
                <div class="emptyContent"></div>
                <div class="checkContent">
                    <div class="checkBox">
                        <div>
                            <img src="@/assets/img/yanzheng.png">
                        </div>
                        <div>
                            <el-input class="inputClass" type="text" placeholder="请输入手机验证码"
                                v-model="registerForm.smsCode" />
                        </div>
                    </div>
                    <div class='checkNum' v-if="!registerLoading" @click="sendPhoneMessage(1)">获取验证码</div>
                    <div class='checkNumDisable' v-else @click="retrySend()">重新发送 ({{ countdown }})</div>
                </div>

                <div class="emptyContent"></div>
                <div class="phoneBox">
                    <div>
                        <img src="@/assets/img/yanzheng.png">
                    </div>
                    <div>
                        <el-input class="inputClass" type="password" placeholder="请输入密码"
                            v-model="registerForm.password" />
                    </div>
                </div>
                <div class="emptyContent"></div>
                <div class="phoneBox">
                    <div>
                        <img src="@/assets/img/yanzheng.png">
                    </div>
                    <div>
                        <el-input class="inputClass" type="password" placeholder="请再次确认密码"
                            v-model="registerForm.confirmPassword" />
                    </div>
                </div>
                <!-- 企业注册特有的营业执照上传 -->
                <div class="" v-if="registerType === '02'"></div>
                <div class="" v-if="registerType === '02'">
                    <div class="mintitle">
                        营业执照
                    </div>
                    <div>
                        <LicenseUploadForStr v-model="registerForm.businessLicense" :limit="1"
                            :upload-type="'enterAuth'">
                        </LicenseUploadForStr>
                    </div>
                </div>
                <div class="czContent">
                    <div @click="setRegister">{{ type == 1 ? '没有账号去注册' : '已有账号去登录' }}</div>
                    <div>|</div>
                    <div @click="forgetTap">忘记密码?</div>
                </div>
                <div class="startButton" @click="loginIn">{{ type == 1 ? '登录' : (type == 2 ? '注册' : '确定重置') }}</div>
                <div class='tokenDay'>
                    <el-checkbox class="checkb" v-model="agreeMS"></el-checkbox>
                    <span @click="agreeMS = !agreeMS" class="qz">我已阅读并同意</span>
                    <span @click.stop="goAgreement(1)" class="xy">《服务协议》</span>
                    <span @click.stop="goAgreement(2)" class="xy">《隐私政策》</span>
                </div>
            </div>


            <!-- 用户找回密码  手机号 密码 二次确认密码--->
            <div class="neic" v-if="type == 3">
                <div class="phoneBox">
                    <div>
                        <img src="@/assets/img/phoneIcon.png">
                    </div>
                    <div>
                        <el-input class="inputClass" type="text" maxlength="11" placeholder="请输入手机号"
                            v-model="findPasswordForm.phonenumber" />
                    </div>
                </div>
                <div class="emptyContent"></div>
                <div class="phoneBox">
                    <div>
                        <img src="@/assets/img/yanzheng.png">
                    </div>
                    <div>
                        <el-input class="inputClass" type="password" placeholder="请输入新密码"
                            v-model="findPasswordForm.password" />
                    </div>
                </div>
                <div class="emptyContent"></div>
                <div class="phoneBox">
                    <div>
                        <img src="@/assets/img/yanzheng.png">
                    </div>
                    <div>
                        <el-input class="inputClass" type="password" placeholder="请再次确认新密码"
                            v-model="findPasswordForm.confirmPassword" />
                    </div>
                </div>
                <div class="emptyContent"></div>
                <div class="checkContent" style="border: none;">
                    <div class="checkBox">
                        <div>
                            <img src="@/assets/img/yanzheng.png">
                        </div>
                        <div>
                            <el-input class="inputClass" type="text" placeholder="请输入手机验证码"
                                v-model="findPasswordForm.smsCode" />
                        </div>
                    </div>
                    <div class='checkNum' v-if="!registerLoading" @click="sendPhoneMessage(2)">获取验证码</div>
                    <div class='checkNumDisable' v-else @click="retrySend()">重新发送 ({{ countdown }})</div>
                </div>


                <div class="czContent">
                    <div @click="setRegister">{{ type == 1 ? '没有账号去注册' : '已有账号去登录' }}</div>
                    <div>|</div>
                    <div @click="forgetTap">忘记密码?</div>
                </div>
                <div class="startButton" @click="loginIn">{{ type == 1 ? '登录' : (type == 2 ? '注册' : '确定重置') }}</div>
            </div>

        </div>
    </div>
</template>

<script>
import { setToken, TokenKey } from '@/utils/auth'
import Cookies from "js-cookie";
import { forgetPassword } from '@/api/login';
import { login, register, sendSmsCode, getSelfDetail, resetPassword } from '@/api/index'
import LicenseUploadForStr from '@/components/LicenseUploadForStr'
export default {
    data() {
        return {
            type: 1, //1登录 2注册 3找回
            checked: true,
            loginForm: {
                phonenumber: '',
                password: '',
            },
            registerForm: {
                username: null,
                nickName: null,
                password: null,
                phonenumber: null,
                confirmPassword: null,
                smsCode: null,
                businessLicense: null,
                userType: null
            },
            registerType: '01', // 01: 个人注册, 02: 企业注册
            //找回密码params
            findPasswordForm: {
                phonenumber: null,
                password: null,
                confirmPassword: null,
                smsCode: null
            },
            uuid: '',
            //发送短信等待90s
            registerLoading: false,
            //90s倒计时
            countdown: 90,
            //setintervier 倒计时
            sendCountdown: null,
            inviteCode: '',
            agreeMS: false

        };
    },
    components: { LicenseUploadForStr },
    beforeDestroy() {
        //清除定时器
        clearInterval(this.sendCountdown)
    },
    created() {
        this.inviteCode = localStorage.getItem('inviteCode') ? localStorage.getItem('inviteCode') : ''
        console.log(this.inviteCodem, "inviteCode")
    },
    methods: {
        //关闭登录注册弹框
        closeMask() {
            this.$parent.showLoginPopup = false;
        },
        //点击登录、注册、重置
        loginIn() {
            if (this.type == 1) {
                if (!this.agreeMS) {
                    this.$message.warning('请先同意用户协议和隐私条例')
                    return
                }
                //登录部分
                if (!this.loginForm.phonenumber || !this.loginForm.password) {
                    this.$message.warning('请完善用户名和密码信息')
                    return
                }
                this.commonLogin(this.loginForm)
            } else if (this.type == 2) {
                if (!this.agreeMS) {
                    this.$message.warning('请先同意用户协议和隐私条例')
                    return
                }
                //注册部分
                if (!this.registerForm.username || !this.registerForm.password || !this.registerForm.smsCode || !this.registerForm.confirmPassword) {
                    this.$message.warning('请完善注册信息')
                    return
                }
                //手机号验证
                if (!this.validatePhone(this.registerForm.phonenumber)) {
                    this.$message.warning('请输入正确的手机号')
                    return
                }
                //密码不能低于6位
                if (this.registerForm.password.length < 6) {
                    this.$message.warning('密码不能低于6位')
                    return
                }
                //二次确认密码
                if (this.registerForm.password != this.registerForm.confirmPassword) {
                    this.$message.warning('两次密码不一致')
                    return
                }
                //企业注册额外验证
                if (this.registerType === '02') {
                    if (!this.registerForm.username) {
                        this.$message.warning('请输入企业名称')
                        return
                    }
                    if (!this.registerForm.businessLicense) {
                        this.$message.warning('请上传营业执照')
                        return
                    }
                }

                //注册接口 - 添加注册类型参数
                register({
                    username: this.registerForm.username,
                    nickName: this.registerForm.username,
                    phonenumber: this.registerForm.phonenumber,
                    password: this.registerForm.password,
                    smsCode: this.registerForm.smsCode,
                    uuid: this.uuid,
                    upInviteCode: this.inviteCode,
                    userType: this.registerType,
                    businessLicense: this.registerForm.businessLicense
                }).then(res => {
                    this.$message.success('账号注册成功')
                    this.commonLogin(this.registerForm)
                })
            } else if (this.type == 3) {
                //重置密码
                if (!this.findPasswordForm.phonenumber || !this.findPasswordForm.password || !this.findPasswordForm.smsCode || !this.findPasswordForm.confirmPassword) {
                    this.$message.warning('请完善重置信息')
                    return
                }
                //手机号验证
                if (!this.validatePhone(this.findPasswordForm.phonenumber)) {
                    this.$message.warning('请输入正确的手机号')
                    return
                }
                //密码不能低于6位
                if (this.findPasswordForm.password.length < 6) {
                    this.$message.warning('密码不能低于6位')
                    return
                }
                //二次确认密码
                if (this.findPasswordForm.password != this.findPasswordForm.confirmPassword) {
                    this.$message.warning('两次密码不一致')
                    return
                }
                //手机号验证
                if (!this.validatePhone(this.findPasswordForm.phonenumber)) {
                    this.$message.warning('请输入正确的手机号')
                    return
                }
                resetPassword(
                    {
                        phonenumber: this.findPasswordForm.phonenumber,
                        newPassword: this.findPasswordForm.password,
                        smsCode: this.findPasswordForm.smsCode,
                        templateType: 2
                    }
                ).then(() => {
                    this.setRegister();
                    this.$message.success('密码重置成功,请重新登录');
                })
            }
        },
        //登录接口
        commonLogin(commonParams) {
            login(commonParams).then(res => {
                var date = new Date();
                date.setTime(date.getTime() + (10 * 24 * 60 * 60 * 1000));
                if (this.checked) {
                    Cookies.set(TokenKey, res.msg, { expires: date })
                    localStorage.setItem('AccessToken_expriesTime', date)
                } else {
                    localStorage.removeItem('AccessToken_expriesTime')
                    setToken(res.msg);
                }

                getSelfDetail().then((response) => {
                    Cookies.set("nickName", response.data.nickName, { expires: date })
                    Cookies.set("avatar", response.data.avatar, { expires: date })
                    this.$parent.nickName = response.data.nickName;
                    this.$parent.isLogin = true;
                    this.$parent.showLoginPopup = false;
                    this.$forceUpdate()
                })
            })
        },
        //重置数据信息
        resetData() {
            this.registerForm.username = null;
            this.registerForm.password = null;
            this.registerForm.smsCode = null;
            this.registerForm.businessLicense = null;
            this.agreeMS = false;
            this.registerType = '01'; //重置为个人注册

            this.loginForm.phonenumber = null;
            this.loginForm.password = null;

            this.findPasswordForm.phonenumber = null;
            this.findPasswordForm.password = null;
            this.findPasswordForm.smsCode = null;
            this.uuid = ''

            this.checked = true;
        },

        //触发文件上传
        triggerUpload() {
            this.$refs.fileInput.click();
        },

        //处理文件上传
        handleFileChange(event) {
            const file = event.target.files[0];
            if (file) {
                //验证文件类型
                const validTypes = ['image/jpeg', 'image/png', 'image/jpg'];
                if (!validTypes.includes(file.type)) {
                    this.$message.warning('请上传JPG或PNG格式的图片');
                    return;
                }

                //验证文件大小 (5MB)
                if (file.size > 5 * 1024 * 1024) {
                    this.$message.warning('文件大小不能超过5MB');
                    return;
                }

                //这里应该上传文件到服务器，这里简单模拟
                //实际项目中应该调用上传接口，获取文件路径
                this.$message.success('文件上传成功');
                this.registerForm.businessLicense = file.name; //模拟文件名

                //清空input，允许重复选择同一文件
                event.target.value = '';
            }
        },
        //忘记密码
        forgetTap() {
            this.resetData();
            this.type = 3;
        },
        //点击账号注册/登录 切换
        setRegister() {
            this.resetData();
            this.type == 3 ? this.type = 1 : (this.type == 1 ? this.type = 2 : this.type = 1)
        },
        //跳转用户协议
        goAgreement(type) {
            // 根据type类型在新标签页打开对应的协议页面
            if (type === 1) {
                // 打开服务协议
                window.open('/agreement/service', '_blank');
            } else if (type === 2) {
                // 打开隐私政策
                window.open('/agreement/privacy', '_blank');
            }
        },
        //发送短信验证码
        sendPhoneMessage(type) {
            clearInterval(this.sendCountdown)

            //type==1 注册 2 找回
            let phone = type == 1 ? this.registerForm.phonenumber : this.findPasswordForm.phonenumber
            //手机号不为空
            if (!phone) {
                this.$message.warning('请填写手机号')
                return
            }
            //手机号验证正确
            if (!this.validatePhone(phone)) {
                this.$message.warning('请输入正确的手机号')
                return
            }
            //发送短信
            sendSmsCode({ phoneNumber: phone, templateType: type }).then((res) => {
                console.log(res, "发送短信")
                this.$message.success("短信验证码发送成功")
                this.registerLoading = true
                //开始倒计时 === > 不可点击
                this.sendCountdown = setInterval(() => {
                    this.countdown -= 1;
                    if (this.countdown < 1) {
                        clearInterval(this.sendCountdown)
                        this.registerLoading = false;
                        this.sendCountdown = null
                        this.countdown = 90
                    }
                }, 1000);
            })
        },
        //重试发送验证码
        retrySend() {
            this.$message.warning(`请${this.countdown}秒后重试`)
        },
        //手机号正则验证
        validatePhone(phoneNumber) {
            const regExp = /^1[3456789]\d{9}$/;
            if (regExp.test(phoneNumber)) {
                return true;
            } else {
                return false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.loginContent {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 99;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 600px;

    .emptyContent {
        height: 20px;
    }

    .loginBox {
        min-width: 480px;
        // min-height: 500px;
        padding-bottom: 25px;
        background-color: white;
        border-radius: 10px;
        overflow: hidden;
        position: relative;

        .closeing {
            width: 25px;
            height: 25px;
            position: absolute;
            right: 20px;
            top: 30px;
            margin-top: -10px;
            cursor: pointer;
        }

        .maintitle {
            font-size: 20px;
            font-weight: bold;
            color: black;
            // text-align: center;
            margin: 30px auto 10px auto;
            padding-left: 40px;
        }

        .mintitle {
            font-size: 15px;
            color: #374151;
            margin-top: 20px;
            margin-bottom: 4px;
        }

        .descLo {
            padding-left: 40px;
            box-sizing: border-box;
            margin: 15px 0;
            color: #4B5563;
            font-size: 14px;

        }

        .neic {
            padding: 10px 40px 0 40px;
        }

        //注册标签页样式
        .register-tabs {
            display: flex;
            border-bottom: 2px solid #f5f5f5;
            margin-bottom: 15px;
        }

        .tab-item {
            flex: 1;
            text-align: center;
            padding: 10px 0;
            cursor: pointer;
            color: #606266;
            font-size: 16px;
            position: relative;
            transition: color 0.3s;
        }

        .tab-item.active {
            color: #ee4c0c;
            font-weight: 500;
        }

        .tab-item.active::after {
            content: '';
            position: absolute;
            bottom: -2px;
            left: 25%;
            width: 50%;
            height: 2px;
            background-color: #ee4c0c;
        }

        //上传区域样式
        .upload-area {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 15px;
            border: 1px dashed #dcdfe6;
            border-radius: 4px;
            cursor: pointer;
            transition: all 0.3s;
        }

        .upload-area:hover {
            border-color: #ee4c0c;
        }

        .upload-text {
            color: #ee4c0c;
            font-size: 14px;
            cursor: pointer;
        }

        .upload-hint {
            color: #909399;
            font-size: 12px;
            margin-top: 5px;
        }

        .upload-tip {
            margin-left: 15px;
            color: #909399;
            font-size: 12px;
        }

        .phoneBox {
            border: 1px solid #e6e6e6;
            display: flex;
            box-sizing: border-box;
            // padding: 5px 0;
            border-radius: 4px;
            overflow: hidden;
            align-items: center;

            ::v-deep .el-input__inner {
                border: none !important;
                padding-left: 0 !important;
            }

            >div:nth-child(1) {
                width: 46px;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;

                img {
                    width: 20px;
                    height: 20px
                }
            }

            >div:nth-child(2) {
                width: calc(100% - 49px);
                display: flex;
                align-items: center;
                margin-left: 5px;

                input {
                    display: block;
                    width: calc(100% - 10px);
                    font-size: 14px;
                    line-height: 28px;
                    color: #262626;
                    background-color: inherit;
                    border-style: none;
                }
            }
        }

        .checkContent {
            display: flex;
            align-items: center;

            ::v-deep .el-input__inner {
                border: none !important;
                padding-left: 0 !important;
            }

            .checkBox {
                border: 1px solid #e6e6e6;
                display: flex;
                box-sizing: border-box;
                // height: 46px;
                overflow: hidden;
                width: calc(100% - 140px);
                border-radius: 4px;
                color: #666666;
                font-size: 12px;

                >div:nth-child(1) {
                    width: 46px;
                    // height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    img {
                        width: 20px;
                        height: 20px
                    }
                }


                >div:nth-child(2) {
                    width: calc(100% - 49px);
                    display: flex;
                    align-items: center;
                    margin-left: 5px;

                    input {
                        display: block;
                        width: calc(100% - 10px);
                        font-size: 14px;
                        line-height: 28px;
                        color: #262626;
                        background-color: #ee4c0c;
                        border-style: none;
                    }
                }
            }

            .checkNum {
                min-width: 110px;
                margin-left: 30px;
                // height: 44px;
                text-align: center;
                padding: 0px 4px;
                white-space: nowrap;
                line-height: 44px;
                display: block;
                font-size: 14px;
                color: #fff;
                background: #ee4c0c;
                border-radius: 8px;
                cursor: pointer;
            }

            .checkNumDisable {
                min-width: 110px;
                margin-left: 30px;
                // height: 44px;
                padding: 0px 4px;
                white-space: nowrap;
                line-height: 44px;
                display: block;
                font-size: 14px;
                color: #333333;
                border: 1px solid #e6e6e6;
                background: white;
                border-radius: 8px;
                cursor: pointer;
                text-align: center;
            }

            .tuimg {
                width: 110px;
                margin-left: 30px;
                height: 44px;
                line-height: 44px;
                display: block;
                font-size: 14px;
                color: #fff;
                border: 1px solid #ee4c0c;

            }
        }

        .tokenDay {
            display: flex;
            justify-content: left;
            color: #666666;
            font-size: 12px;
            margin-top: 10px;
            align-items: center;

            .checkb {
                margin-top: 1px;
                margin-right: 4px;
            }
        }

        .qz:hover {
            color: #ee4c0c;
            cursor: pointer;

        }

        .xy {
            color: #2592F6;
            cursor: pointer;
        }

        .czContent {
            height: 30px;
            font-size: 12px;
            color: #ee4c0c;
            display: flex;
            height: 40px;
            align-items: center;
            justify-content: center;
            padding: 15px 0;

            >div {
                cursor: pointer;
            }

            >div:nth-child(2) {
                margin: 0 10px;
            }
        }

        .startButton {
            overflow: hidden;
            width: 100%;
            padding: 5px 0;
            line-height: 40px;
            border: 0 none;
            background-color: #ee4c0c;
            color: #ffffff;
            text-align: center;
            font-size: 14px;
            cursor: pointer;

        }

        .bottomTip {
            margin-top: 15px;
            line-height: 20px;
            color: #99999c;
            text-align: left;
            font-size: 12px;

            span {
                color: #ee4c0c;
                cursor: pointer;

            }
        }
    }
}

::v-deep .el-input.is-disabled .el-input__inner {
    background-color: white !important;
}
</style>